export default {
  state: {
    miniSideBar: false,
    activeUserCount: 0,
    activeAccountCount: 0,
    userData: JSON.parse(localStorage.getItem("user")) || null,
  },
  mutations: {
    setMiniSidebar(state, sidebar) {
      state.miniSideBar = sidebar;
    },
    resetUserState(state) {
      state.user = null;
      state.userData = null;
      state.activeUserCount = 0;
      state.activeAccountCount = 0;
      state.miniSideBar = false;
    },
    setUser(state, user) {
      state.user = user;
      state.userData = user;
      state.activeUserCount++;
    },
    setActiveUserCount(state, count) {
      state.activeUserCount = count;
    },
    setActiveAccountCount(state, count) {
      state.activeAccountCount = count;
    },
    updateUserData(state, userData) {
      state.userData = userData;
    },
  },
  actions: {
    getMiniSidebar({ commit }) {
      commit("setMiniSidebar", true);
    },
    login({ commit }, user) {
      commit("setUser", user);
    },
    logout({ commit }) {
      commit("resetUserState");
      localStorage.removeItem("user");
    },
    updateActiveUserCount({ commit }, count) {
      commit("setActiveUserCount", count);
    },
    updateActiveAccountCount({ commit }, count) {
      commit("setActiveAccountCount", count);
    },
    updateUserData({ commit }, userData) {
      commit("updateUserData", userData);
    },
  },
  getters: {
    miniSideBar: (s) => s.miniSideBar,
    activeUserCount: (s) => s.activeUserCount,
    activeAccountCount: (s) => s.activeAccountCount,
    userData: (s) => s.userData,
  },
};
